import React from 'react'
import { Link } from "gatsby"
import styled from '@emotion/styled';
import { green01, pcHeaderH, fontEn, text, mq, breakP, grayBorder, grayBg, baseDurationTime } from '../../_style';
import PageMain from '../../components/organisms/pageMain';
import imgMain from '../../assets/imgs/about/history/img-main.jpg';
import imgMainSp from '../../assets/imgs/about/history/sp/img-main.jpg';
import Br from '../../components/atoms/br';
import Image from '../../components/atoms/image';
import Text from '../../components/atoms/text';
import ContentWidth from '../../components/organisms/contentWidth';
import Heading from '../../components/atoms/heading';
import SizedImage from '../../components/molecules/sizedImage';
import InnerLinkGroup from '../../components/molecules/about/innerLinkGroup';
import SectionLineup from '../../components/organisms/sectionLineup';
import InnerLink from '../../components/atoms/about/innerLink';
import { Helmet } from 'react-helmet';
import AboutMain from '../../components/organisms/aboutDetail/aboutDetailMain';
import ArticleHeader from '../../components/molecules/articleHeader';
import HistoryItemBody from '../../components/organisms/history/historyItemBody';

const Container = styled.div`
`
const HistoryMain = styled.div`
  position: relative;
  padding-top: 109px;
  margin-bottom: 90px;
  background-color: ${grayBg};
  ${mq.sp} {
    padding-top: 60px;
  }
`
const HistoryMainInner = styled.div`
  padding-bottom: 120px;
  ${mq.sp} {
    padding-bottom: 60px;
  }
  & > div:first-of-type {
    position: relative;
  }
`
const Start = styled.span`
  display: block;
  margin-bottom: 112px;
  margin-left: 89px;
  color: ${green01};
  font-family: ${fontEn};
  font-size: 26px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 0.33em;
  ${mq.sp} {
    margin-bottom: 57px;
    margin-left: 0;
    font-size: 16px;
  }
`
const HistoryLine = styled.div`
  position: absolute;
  top: 54px;
  bottom: 22px;
  left: 172px;
  width: 40px;
  border-top: 4px solid ${green01};
  ${mq.sp} {
    top: 45px;
    /* left: 33px; */
    left: 18px;
    width: 35px;
  }
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  &::before {
    width: 12px;
    background-color: ${green01};
    ${mq.sp} {
      width: 12px;
    }
  }
  & > span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 10px;
    background-color: ${grayBg};
    &:first-of-type {
      bottom: 5px;
    }
    &:nth-of-type(2) {
      bottom: 20px;
    }
    &:last-of-type {
      bottom: 35px;
    }
  }
`
const HistoryItem = styled.div`
  position: relative;
  & + & {
    margin-top: 90px;
  }
`
const Year = styled.div`
  margin-bottom: 60px;
  font-family: ${fontEn};
  color: ${grayBg};
  font-size: 62px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 0.1em;
  text-shadow: 1px 1px 0 ${green01}, -1px -1px 0 ${green01}, -1px 1px 0 ${green01}, 1px -1px 0 ${green01}, 0px 1px 0 ${green01},  0-1px 0 ${green01}, -1px 0 0 ${green01}, 1px 0 0 ${green01};
  ${mq.pc} {
    padding-left: 237px;
  }
  ${mq.sp} {
    margin-bottom: 45px;
    padding-left: 51px;
    font-size: 42px;
  }
`
const HistoryItemDot = styled.i`
  display: block;
  position: relative;
  top: -8px;
  left: 0;
  width: 50px;
  min-width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  transform: scale3d(0, 0, 1);
  transition: transform ${parseFloat(baseDurationTime) * 2}s ease;
  will-change: transform;
  .is-shown & {
    transform: scale3d(1, 1, 1);
  }
  ${mq.sp} {
    top: -1px;
    width: 30px;
    min-width: 30px;
    height: 30px;
  }
  &::before {
    content: "";
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 12px;
    height: 12px;
    margin: auto;
    background-color: ${green01};
    border-radius: 50%;
    box-shadow: 0px 4px 8px 0px rgba(0, 171, 132, 0.5);
    transition: transform ${baseDurationTime} ease ${parseFloat(baseDurationTime) * 2}s;
    will-change: transform;
    .is-shown & {
      transform: scale3d(1, 1, 1);
    }
    ${mq.sp} {
      width: 7px;
      height: 7px;
    }
  }
`
const HistoryItemBodyInner = styled.div`
  display: flex;
  margin-left: -7px;
  ${mq.sp} {
    margin-left: -4px;
  }
  &::before {
    content: "";
    width: 82px;
    min-width: 82px;
    height: 1px;
    margin-top: 17px;
    margin-right: 10px;
    margin-left: -17px;
    background-color: ${green01};
    z-index: 40;
    transform: scale3d(0, 1, 1);
    transform-origin: left;
    transition: transform ${baseDurationTime} ease ${parseFloat(baseDurationTime) * 1.5}s;
    will-change: transform;
    .is-shown & {
      transform: scale3d(1, 1, 1);
    }
    ${mq.sp} {
      width: 25px;
      min-width: 25px;
      margin-top: 14px;
      margin-right: 15px;
      margin-left: -7px;
    }
  }
`
const HistoryItemContent = styled.div`
  ${mq.sp} {
    margin-left: -7px;
  }
`
const HistoryItemContentInner = styled.div`
  opacity: 0;
  transform: translate3d(0, 50px, 0);
  transition: opacity ${parseFloat(baseDurationTime) * 2}s ease ${parseFloat(baseDurationTime) * 1.5}s, transform ${parseFloat(baseDurationTime) * 2}s ease ${parseFloat(baseDurationTime) * 1.5}s;
  will-change: transform, opacity;
  .is-shown & {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  ${mq.pc} {
    display: flex;
  }
`
const HistoryItemTextSet = styled.div`
  ${mq.pc} {
    max-width: 405px;
    margin-right: 30px;
  }
  ${mq.sp} {
    margin-bottom: 30px;
    padding-top: 0;
  }
  h2 {
    padding-bottom: 30px;
  }
`
const HistoryItemContentBox = styled.div`
  margin-top: 30px;
  padding: 33px 35px;
  border: 1px solid ${grayBorder};
  border-radius: 2px;
  background-color: #fff;
  ${mq.pc} {
    display: flex;
  }
  ${mq.sp} {
    margin-top: 30px;
    padding: 22px 20px;
  }
`
const HistoryItemContentBoxInner = styled.div`
  ${mq.pc} {
    margin-right: 35px;
  }
  ${mq.sp} {
    margin-bottom: 30px;
  }
`
const HistoryItemContentBoxTitle = styled.h4`
  margin-bottom: 19px;
  color: ${green01};
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
`
const BottomImage = styled.div`
  margin-top: 60px;
  opacity: 0;
  transform: translate3d(0, 50px, 0);
  transition: opacity ${parseFloat(baseDurationTime) * 2}s ease ${parseFloat(baseDurationTime) * 1.5}s, transform ${parseFloat(baseDurationTime) * 2}s ease ${parseFloat(baseDurationTime) * 1.5}s;
  will-change: transform, opacity;
  .is-shown & {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`
export default class History extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isSp: false};
    this.resizeHandler = this.resizeHandler.bind(this);
  }
  componentDidMount() {
    this.setState({isSp: breakP >= window.innerWidth});
    window.addEventListener('resize', this.resizeHandler);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }
  resizeHandler() {
    this.setState({isSp: breakP >= window.innerWidth});
  }
  render() {
    return(
      <Container>
        <Helmet
          title="モンダミンの歴史 | モンダミン | アース製薬"
          meta={[
              { name: 'description', content: '日本でまだ洗口液が一般的ではなかった1987年、モンダミンは「日本人が毎日使いたくなるような洗口液」をコンセプトに誕生しました。ブランドの誕生から現在まで、モンダミンの歴史についてご紹介します。' },
              { name: 'keywords', content: 'モンダミン,もんだみん,mondahmin,オーラルケア,アース製薬' }
          ]}
        >
          <body data-block-header="true" />
        </Helmet>
        <AboutMain bg={imgMain} bgSp={imgMainSp}></AboutMain>
        <HistoryMain>
          <ContentWidth>
            <ArticleHeader title={'モンダミンの歴史'}></ArticleHeader>
          </ContentWidth>
          <HistoryMainInner>
            <ContentWidth>
              <Start>START</Start>
              <HistoryLine>
              </HistoryLine>
              <HistoryItem>
                  <Year>1987</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>日本人のための洗口液 <Br onlyPc />モンダミン誕生</Heading>
                          <Text>当時、アメリカで既に人気の「洗口液」に<Br onlyPc />当時の社長が注目し、開発に着手しました。<Br onlyPc />日本の市場では前例がほとんどなかったため、<Br onlyPc />クリアすべき基準そのものから構築。<Br onlyPc />特に日本人好みの香味を追求し、<Br onlyPc />モンダミン ペパーミントは1987年に誕生。<Br onlyPc />翌88年にはシナモン味を発売しました。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-01.png'} pcWidth={285} spWidth={180} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                      <HistoryItemContentBox>
                        <HistoryItemContentBoxInner>
                          <HistoryItemContentBoxTitle>モンダミンの名前の由来</HistoryItemContentBoxTitle>
                          <SizedImage spOnly={true} filename={'about/history/img-logo.png'} pcWidth={99} spWidth={99}></SizedImage>
                          <Text>近代的なという意味の「modern」とフランス語で私の友達、恋人を意味する「monami(e)」に医薬品などで用いられる「〜イン」の語尾を組み合わせて、「モンダミン」というブランド名が誕生しました。</Text>
                        </HistoryItemContentBoxInner>
                        <SizedImage pcOnly={true} filename={'about/history/img-logo.png'} pcWidth={99} spWidth={99}></SizedImage>
                      </HistoryItemContentBox>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                  <Year>1990</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>ストロングミント発売</Heading>
                          <Text>甘さをおさえた辛口タイプとして追加し、ラインナップを充実。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-02.png'} pcWidth={165} spWidth={160} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                  <Year>1993</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>「すっきり清潔、<Br />お口の健康を守る」で大ヒット！</Heading>
                          <Text>「お口すっきり、さわやか。いい息ながもち。」といった口臭予防のメインコピーから、「20秒ですっきり清潔。お口の健康を守る！！」というお口の健康を意識したメインコピーに変更。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-03.png'} pcWidth={238} spWidth={190} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                      <HistoryItemContentBox>
                        <HistoryItemContentBoxInner>
                          <HistoryItemContentBoxTitle>当時のCM</HistoryItemContentBoxTitle>
                          <Text>井森美幸さんを採用。キャッチコピーは当時から「お口、クチュ、クチュ。モンダミン」でした。</Text>
                        </HistoryItemContentBoxInner>
                        <SizedImage filename={'about/history/img-small-01.png'} pcWidth={136} spWidth={215}></SizedImage>
                      </HistoryItemContentBox>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                  <Year>1995</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>センシティブ発売</Heading>
                          <Text>歯や歯ぐきが刺激に弱い方や、お口にトラブルが起こりやすい方も安心して使える低刺激タイプを追加。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-04.png'} pcWidth={166} spWidth={160} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                  <Year>2012</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>ナイトクリア、メディカルケア、<Br/>Kid’s発売</Heading>
                          <Text>夜用のナイトクリア、歯肉炎予防のメディカルケア、お子様のむし歯予防ができるKid’sを追加し、専用ケアタイプと子ども用のアイテムを充実。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-05.png'} pcWidth={317} spWidth={240} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                  <Year>2015</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>プレミアムケア発売</Heading>
                          <Text>モンダミン史上最多の7つの効果を持つプレミアムケアを発売。これ1本でお口のトータルケアが可能に。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-06.png'} pcWidth={153} spWidth={160} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                  <Year>2019</Year>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>NEXT 歯周ケア 発売</Heading>
                          <Text>モンダミンブランド初の、本格的に歯周病ケアができる液体ハミガキを発売。</Text>
                        </HistoryItemTextSet>
                        <SizedImage filename={'about/history/img-07.png'} pcWidth={153} spWidth={160} flexibleBase={721}></SizedImage>
                      </HistoryItemContentInner>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
              <HistoryItem>
                <HistoryItemBody>
                  <HistoryItemDot></HistoryItemDot>
                  <HistoryItemBodyInner>
                    <HistoryItemContent>
                      <HistoryItemContentInner>
                        <HistoryItemTextSet>
                          <Heading>お口の悩みに選べる<Br />豊富なラインナップ</Heading>
                          <Text>お子様から高齢者の方まで。<Br />様々なお口の悩みに合わせて最適な1本をお選びいただけます。</Text>
                        </HistoryItemTextSet>
                      </HistoryItemContentInner>
                      <BottomImage>
                        {this.state.isSp ? <SizedImage filename={'about/history/sp/img-08.png'} pcWidth={689} spWidth={260} flexibleBase={689}></SizedImage> : <SizedImage filename={'about/history/img-08.png'} pcWidth={689} spWidth={240} flexibleBase={689}></SizedImage>}
                      </BottomImage>
                    </HistoryItemContent>
                  </HistoryItemBodyInner>
                </HistoryItemBody>
              </HistoryItem>
            </ContentWidth>
            <ContentWidth>
              <InnerLinkGroup path={this.props.path}></InnerLinkGroup>
            </ContentWidth>
          </HistoryMainInner>
        </HistoryMain>
        <SectionLineup withoutHead></SectionLineup>
      </Container>
    );
  }
}
